import { ChangeEvent, useState } from 'react';
import {
  VStack,
  Text,
  InputGroup,
  InputLeftAddon,
  Input,
  HStack,
  Box,
  IconButton,
} from 'native-base';
// import PhoneInput from 'react-phone-number-input/input';

// APIs
import { regionFlag } from '@breakroom-nx/apis';

// Assets
import { theme } from '@breakroom-nx/assets';
import {
  EyeIcon as HidePassIcon,
  EyeOffIcon as ShowPassIcon,
} from 'react-native-heroicons/solid';

import { IdentificationIcon as NameIcon } from 'react-native-heroicons/outline';

// Classes & Types
import { InputType } from '@breakroom-nx/helpers';
import { ColorType } from 'native-base/lib/typescript/components/types';

// Props
type Props = {
  onSubmitEditing?: any;
  title?: string;
  type?: InputType;
  isRequired?: boolean;
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters' | undefined;
  autoCorrect?: boolean;
  autoFocus?: boolean;
  autoCompleteType?:
    | 'off'
    | 'name'
    | 'email'
    | 'password'
    | 'tel'
    | 'cc-csc'
    | 'cc-exp'
    | 'cc-exp-month'
    | 'cc-exp-year'
    | 'cc-number'
    | 'postal-code'
    | 'street-address'
    | 'username'
    | undefined;
  placeholder?: string;
  onChangeText: any;
  onBlur: any;
  value?: any;
  disabled?: boolean;
  color?: ColorType;
  inactiveTextColor?: ColorType;
  textAlign?: ResponsiveValue<Property.TextAlign | undefined>;
  maxLength?: number | undefined;
  rightIcon?: JSX.Element | JSX.Element[] | undefined;
};

export const TextField = ({
  onSubmitEditing = undefined,
  title = undefined,
  type = InputType.Text,
  isRequired = true,
  autoCapitalize = 'none',
  autoCorrect = false,
  autoCompleteType = undefined,
  autoFocus = false,
  placeholder = undefined,
  onChangeText,
  onBlur,
  value = undefined,
  disabled = false,
  color = 'primary.400',
  inactiveTextColor = undefined,
  textAlign = undefined,
  maxLength = undefined,
  rightIcon = undefined,
}: Props) => {
  const [focused, setFocused] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const requiredAsterisk = () => {
    return <Text color={'primary.300'}>*</Text>;
  };
  const flag = () => {
    return (
      <Box p={4} borderRightWidth={1} borderColor={'surface.300'} fontSize={16}>
        <Text>{regionFlag('US')}</Text>
      </Box>
    );
  };

  return (
    <VStack space={1} flex={1}>
      <HStack space={0.5}>
        {title ? (
          <Text color={'white'} fontWeight={500} fontSize={14}>
            {title}
          </Text>
        ) : null}
        {isRequired ? requiredAsterisk : null}
      </HStack>
      <HStack alignItems={'center'}>
        {type === InputType.Phone ? flag : null}

        {type == InputType.Username ? (
          <Text
            mr={-2}
            mb={1}
            fontWeight={400}
            fontSize={13}
            color={color}
            mt={-1}
          >
            @
          </Text>
        ) : null}

        {/* {type == InputType.Name ? (
          <NameIcon color={theme.colors.primary[400]} />
        ) : null} */}

        <Input
          onFocus={() => {
            setFocused(true);
          }}
          onBlur={() => {
            setFocused(false);
          }}
          onSubmitEditing={onSubmitEditing}
          isDisabled={disabled}
          onChangeText={onChangeText}
          value={value}
          flex={1}
          pl={type === InputType.Username ? 4 : -1}
          //                                     ^
          // -1 instead of 0 to fix InputRightElement bug (see below)
          pb={3}
          placeholder={
            placeholder !== undefined ? placeholder : title ? title : type
          }
          color={focused ? 'white' : inactiveTextColor ?? null}
          placeholderTextColor={'surface.400'}
          autoCompleteType={autoCompleteType}
          autoCapitalize={autoCapitalize}
          autoCorrect={autoCorrect}
          autoFocus={autoFocus}
          height="full"
          fontSize={16}
          fontWeight={400}
          letterSpacing={'-0.3px'}
          alignSelf={'stretch'}
          secureTextEntry={type == InputType.Password && !showPass}
          bg={'transparent'}
          borderTopColor={'transparent'}
          borderRightColor={'transparent'}
          borderLeftColor={'transparent'}
          focusOutlineColor={'transparent'}
          borderBottomColor={focused ? color : 'surface.300'}
          borderBottomWidth={2}
          borderLeftWidth={0}
          borderRightWidth={0}
          rounded={0}
          textAlign={textAlign}
          maxLength={maxLength}
          /* BUG
            Description: Adding InputRightElement adds ~2px of paddingLeft to input text.
            Solution: default paddingLeft to -1 instead of 0 (see above)
          */
          InputRightElement={
            rightIcon ? (
              rightIcon
            ) : type == InputType.Password ? (
              <IconButton
                onPress={() => {
                  setShowPass(!showPass);
                }}
                borderRadius={'full'}
                padding={1}
                size={8}
                icon={
                  showPass ? (
                    <HidePassIcon color={theme.colors.surface[400]} />
                  ) : (
                    <ShowPassIcon color={theme.colors.surface[400]} />
                  )
                }
                _pressed={{ backgroundColor: 'transparent', opacity: 0.7 }}
              />
            ) : undefined
          }
        />
      </HStack>
    </VStack>
  );
};
